import type { Text2AudioFormParams } from '@/app/stores/slices/task-form';

/**
 * 获取文生音频段的最大有效结束时间
 *
 * @param segments 文生音频的 segments
 * @returns 最大有效结束时间，如果没有有效段则返回 1
 */
export const getText2AudioMaxValidSegmentEndTime = (segments: Text2AudioFormParams['segments']): number => {
  const validEndTimes =
    segments
      ?.filter((segment) => !((segment.startTime ?? 0) === 0 && (segment.endTime ?? 0) === 0))
      .map((segment) => segment.endTime ?? 0) ?? [];

  if (validEndTimes.length === 0) return 1;
  return Math.max(...validEndTimes);
};
